import React from 'react';
import * as R from 'ramda';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
// forms
import { Fieldset2 } from '../../';
//////////////////////////////////////////////////

const OPTION = 'option';

const getValidationSchema = (optionRequired, isMulti = false) => {
  if (G.isFalse(optionRequired)) return {};

  if (isMulti) return { [OPTION]: G.yupArrayRequired };

  return {
    [OPTION]: Yup.string()
      .nullable(true)
      .required(G.getRequiredLocaleTxt()),
  };
};

export const getFields = ({
  width,
  label,
  options,
  isMulti,
  useMultiSelectMaxHeight,
  valueContainerMaxHeight,
}) => [
  {
    label,
    isMulti,
    options,
    fieldName: OPTION,
    type: 'reactSelect',
    useMultiSelectMaxHeight,
    valueContainerMaxHeight,
    inputWrapperStyles: { mb: 25, width },
  },
];

export const enhance = compose(
  withFormik({
    enableReinitialize: true,
    displayName: 'SINGLE_SELECT_DROPDOWN',
    handleSubmit: (values, { props }) => {
      const { submitAction, submitValues } = props;

      if (submitValues) return submitAction(values);

      submitAction(values[OPTION]);
    },
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues({ [OPTION]: null }, initialValues),
    validationSchema: ({ isMulti, optionRequired }) =>
      Yup.object().shape(getValidationSchema(optionRequired, isMulti)),
  }),
  pure,
);

export const SelectDropdownForm = enhance((props) => {
  const {
    options,
    handleSubmit,
    cancelAction,
    isMulti = false,
    fieldWidth = 300,
    fieldLabel = null,
    additionFields = [],
    fieldsWrapperStyles,
    valueContainerMaxHeight = 200,
    useMultiSelectMaxHeight = false,
  } = props;

  const fields = R.concat(getFields({
    options,
    isMulti,
    width: fieldWidth,
    label: fieldLabel,
    useMultiSelectMaxHeight,
    valueContainerMaxHeight,
  }), additionFields);

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...props}
        fields={fields}
        fieldsWrapperStyles={{ pt: 15, ...fieldsWrapperStyles }}
      />
      <FormFooter closeModal={cancelAction} />
    </form>
  );
});
